module.exports = __webpack_public_path__ + "static/media/exclamation.0cb158ad.svg";